import styled from "styled-components";

export default function BannerDots({ dots }) {
  return (
    <DotWrapper>
      {dots.map((value, index) => (
        <BannerDot key={`main-banner-dot-${index}`} className={value.props.className === 'slick-active' && 'activated'}/>
      ))}
    </DotWrapper>
  )
}

const DotWrapper = styled.div`
    position : absolute;
    left:calc(100vw * (17 / 375));
    bottom:calc(100vw * (14 / 375));
    width: fit-content;
    height: calc(100vw * (7 / 375));
`;

const BannerDot = styled.span`
    display: inline-block;
    margin: 0 calc(100vw * (4.5 / 375));
    width: calc(100vw * (7 / 375));
    height: calc(100vw * (7 / 375));
    background: #ffffff66;
    &:first-child {
        margin-left: 0;
    }
    &:last-child {
        margin-right: 0;
    }
    &.activated {
        background: #ffffff;
    }
    border-radius: 100%;
`;